import React from 'react';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';

export default function InfoCircleIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 20.25C7.44365 20.25 3.75 16.5563 3.75 12C3.75 7.44365 7.44365 3.75 12 3.75C16.5563 3.75 20.25 7.44365 20.25 12C20.25 16.5563 16.5563 20.25 12 20.25ZM2.25 12C2.25 17.3848 6.61522 21.75 12 21.75C17.3848 21.75 21.75 17.3848 21.75 12C21.75 6.61522 17.3848 2.25 12 2.25C6.61522 2.25 2.25 6.61522 2.25 12Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.491 11.7512C11.4216 11.75 11.3413 11.75 11.2422 11.75C10.828 11.75 10.4922 11.4142 10.4922 11C10.4922 10.5858 10.828 10.25 11.2422 10.25C11.2536 10.25 11.2651 10.25 11.2766 10.25C11.4817 10.2499 11.7035 10.2498 11.8908 10.275C12.1101 10.3045 12.3903 10.3803 12.6261 10.6161C12.8619 10.8519 12.9377 11.1321 12.9672 11.3514C12.9924 11.5386 12.9923 11.7604 12.9922 11.9656C12.9922 11.9771 12.9922 11.9886 12.9922 12V17C12.9922 17.4142 12.6564 17.75 12.2422 17.75C11.828 17.75 11.4922 17.4142 11.4922 17V12C11.4922 11.9009 11.4922 11.8206 11.491 11.7512Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.992 8C10.992 7.44772 11.4397 7 11.992 7H12.001C12.5533 7 13.001 7.44772 13.001 8C13.001 8.55228 12.5533 9 12.001 9H11.992C11.4397 9 10.992 8.55228 10.992 8Z"
      />
    </SvgIcon>
  );
}
